import React from 'react'
import PropTypes from 'prop-types'

import MenuPortal from './menu-portal'
import MenuDrawer from './menu-drawer'
import Overlay from '../../static/overlay'
import {Item} from './menu-item'

class MenuDrawerButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer: false,
      wtf: false, //--for some reason, this is needed
    }
  }

  toggleVisibility = (forceVisible) => {
    let visibility = !this.state.showDrawer;
    if(forceVisible !== undefined) visibility = forceVisible
    this.setState({ showDrawer: visibility})
  }

  render() {
    const drawer = this.state.showDrawer ? (
      <MenuPortal>
        <Overlay toggleVisibility={this.toggleVisibility}/>
        <MenuDrawer toggleVisibility={this.toggleVisibility}/>
      </MenuPortal>
      ) : null;
    return(
      <React.Fragment>
        <Item 
          onMouseLeave={()=>{this.setState({wtf: false})}} 
          onClick={()=>{this.toggleVisibility()}}>
          {this.props.text}
        </Item> 
        {drawer}
      </React.Fragment>
    );
  }
}

MenuDrawerButton.propTypes = {
  text: PropTypes.string
}

MenuDrawerButton.defaultProps = {
  text: 'button'
}

export default MenuDrawerButton





// WEBPACK FOOTER //
// ./src/components/interactive/menu/menu-drawer-button.js